import { SVGAttributes } from 'react'
import clsx from 'clsx'
import classes from './BuildingBlocks.module.scss'

export const JigIcon = ({ location }) => {
  const horizontal = location === 'top' || location === 'bottom' ? true : false

  const className = clsx(
    classes.jig,
    classes[`jig__${location}`],
    horizontal ? classes[`jig__horizontal`] : classes[`jig__vertical`],
  )

  return (
    <>
      {horizontal ? (
        <HorizontalJig className={clsx(className)} />
      ) : (
        <VerticalJig className={className} />
      )}
    </>
  )
}

const HorizontalJig = ({ className }: SVGAttributes<SVGAElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 47 20'
      className={className}
    >
      <mask
        id='a'
        width='21'
        height='18'
        x='13'
        y='2'
        fill='#000'
        maskUnits='userSpaceOnUse'
      >
        <path fill='#fff' d='M13 2h21v18H13z' />
        <path d='M33 9.5a9.5 9.5 0 0 1-19 0V3h19v6.5Z' />
      </mask>
      <path
        fill='#080A1E'
        d='M33 9.5a9.5 9.5 0 0 1-19 0V3h19v6.5Z'
        className={classes.jig_background}
      />
      <path
        fill='#1A1F39'
        d='M14 3V2h-1v1h1Zm19 0h1V2h-1v1ZM15 9.5V3h-2v6.5h2ZM32 3v6.5h2V3h-2ZM14 4h9.5V2H14v2Zm9.5 0H33V2h-9.5v2Zm0 14A8.5 8.5 0 0 1 15 9.5h-2C13 15.299 17.701 20 23.5 20v-2Zm0 2C29.299 20 34 15.299 34 9.5h-2a8.5 8.5 0 0 1-8.5 8.5v2Z'
        mask='url(#a)'
      />
      <path
        fill='#080A1E'
        d='M10 3.502h27v-3H10z'
        className={classes.jig_background}
      />
    </svg>
  )
}

const VerticalJig = ({ className }: SVGAttributes<SVGAElement>) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      fill='none'
      viewBox='0 0 20 48'
      className={className}
    >
      <mask
        id='b'
        width='18'
        height='21'
        x='.01'
        y='13.5'
        fill='#000'
        maskUnits='userSpaceOnUse'
      >
        <path fill='#fff' d='M.01 13.5h18v21h-18z' />
        <path d='M10.51 33.5a9.5 9.5 0 1 1 0-19h6.5v19h-6.5Z' />
      </mask>
      <path
        fill='#080A1E'
        d='M10.51 33.5a9.5 9.5 0 1 1 0-19h6.5v19h-6.5Z'
        className={classes.jig_background}
      />
      <path
        fill='#1A1F39'
        d='M17.01 14.5h1v-1h-1v1Zm0 19v1h1v-1h-1Zm-6.5-18h6.5v-2h-6.5v2Zm6.5 17h-6.5v2h6.5v-2Zm-1-18V24h2v-9.5h-2Zm0 9.5v9.5h2V24h-2Zm-14 0a8.5 8.5 0 0 1 8.5-8.5v-2C4.71 13.5.01 18.201.01 24h2Zm-2 0c0 5.799 4.7 10.5 10.5 10.5v-2a8.5 8.5 0 0 1-8.5-8.5h-2Z'
        mask='url(#b)'
      />
      <path
        fill='#080A1E'
        d='M16.508 10.5v27h3v-27z'
        className={classes.jig_background}
      />
    </svg>
  )
}
